import React, { useState } from 'react';
import CTASection from '../components/CTASection';
import '../styles/Contact.css';

const Contact = () => {
  // const [formData, setFormData] = useState({
  //   name: '',
  //   email: '',
  //   subject: '',
  //   message: ''
  // });

  // const handleChange = (e) => {
  //   setFormData({
  //     ...formData,
  //     [e.target.name]: e.target.value
  //   });
  // };

  // const handleSubmit = (e) => {
  //   e.preventDefault();
  //   // Handle form submission here
  //   console.log('Form submitted:', formData);
  //   alert('Thank you for your message! We\'ll get back to you soon.');
  // };

  return (
    <div>
    <div className="about-page section-marg">
      <div className="container">
        <h1>Get in touch</h1>
        <div className="flex gap-8 contact-container">
        <div className="contact-wrapper boxed">
          <p className="small-contact-title">General support</p>
          <p className="page-intro">
          If you experience any problems with Fiktion, please reach out via email. 
          </p>
          <div className="flex flex-row gap-8 items-center">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M3 6.39999C3 5.29542 3.89543 4.39999 5 4.39999H15C16.1046 4.39999 17 5.29542 17 6.39999V13.6C17 14.7046 16.1046 15.6 15 15.6H5C3.89543 15.6 3 14.7046 3 13.6V6.39999Z" stroke="black" stroke-width="1.25"/>
<path d="M4.01074 4.94379L8.58589 9.51907C9.36693 10.3001 10.6333 10.3001 11.4143 9.51909L15.9896 4.94379" stroke="black" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
</svg>

            <a href={`mailto:ellabnitram@gmail.com?subject=${encodeURIComponent('I need help with...')}`}>Support</a>
          </div>
        </div>
        <div className="contact-wrapper boxed">
        <p className="small-contact-title">Feature requests</p>
          <p className="page-intro">
          If you have any feature requests for Fiktion, I would love to hear them.
        </p>
        <div className="flex flex-row gap-8 items-center">
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M3 6.39999C3 5.29542 3.89543 4.39999 5 4.39999H15C16.1046 4.39999 17 5.29542 17 6.39999V13.6C17 14.7046 16.1046 15.6 15 15.6H5C3.89543 15.6 3 14.7046 3 13.6V6.39999Z" stroke="black" stroke-width="1.25"/>
<path d="M4.01074 4.94379L8.58589 9.51907C9.36693 10.3001 10.6333 10.3001 11.4143 9.51909L15.9896 4.94379" stroke="black" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
</svg>

            <a href={`mailto:ellabnitram@gmail.com?subject=${encodeURIComponent('Fiktion Feature Request.')}`}>Features</a>
          </div>
        </div>
        </div>
        <div className="contact-wrapper coffee-wrapper">
          <p className="small-contact-title">Coffee?</p>
          <p className="page-intro">
          You don't have to; but if you’d like to buy me a coffee, I wouldn't say no.
          </p>
          <div className="flex flex-row gap-8 items-center">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M5.40364 14.5962L14.596 5.40381M14.596 5.40381H6.67156M14.596 5.40381V13.3283" stroke="black" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
</svg>

            <a href="https://buymeacoffee.com/martinballe">Buy me a coffee</a>
          </div>
        </div>
      </div>
    </div>
    <div className="divider"></div>

    <CTASection />
    </div>
  );
};

export default Contact;


